export enum ContentType {
    Course = 2,
    Exam = 1,
    AllContent = 0
}
